/* ==========================================================================
   PLAYNOSTALGIA — pn-cart.js
   Panier AJAX natif Shopify (cart/add.js, cart/change.js) + drawer.
   Le rendu du drawer est régénéré via la Section Rendering API pour que
   les prix restent formatés par Liquid (devise, taxes, remises).
   ========================================================================== */
(function () {
  'use strict';

  var PN = (window.PN = window.PN || {});
  var SECTION_ID = 'pn-cart-drawer';

  function getDrawer() {
    return document.getElementById('pn-cart-drawer');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    PN.lockScroll(true);
    PN.trapFocus(drawer);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    PN.releaseFocus(drawer);
    PN.lockScroll(false);
  }

  PN.openCart = openDrawer;
  PN.closeCart = closeDrawer;

  function updateBubbles(count) {
    var bubbles = document.querySelectorAll('[data-pn-cart-count]');
    Array.prototype.forEach.call(bubbles, function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* Recharge le contenu du drawer depuis le serveur */
  function refresh() {
    return fetch('/?sections=' + SECTION_ID)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('pn-cart-drawer');
        var current = getDrawer();
        if (fresh && current) {
          var wasOpen = current.getAttribute('aria-hidden') === 'false';
          current.innerHTML = fresh.innerHTML;
          current.setAttribute('aria-hidden', wasOpen ? 'false' : 'true');
          var count = 0;
          if (fresh.hasAttribute('data-cart-count')) {
            current.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count'));
            count = parseInt(fresh.getAttribute('data-cart-count'), 10);
          }
          updateBubbles(isNaN(count) ? 0 : count);
        }
      })
      .catch(function () {
        /* silencieux : le panier reste accessible via /cart */
      });
  }

  PN.refreshCart = refresh;

  /* ---------- Ajout au panier ---------- */
  function handleAddForm(form, e) {
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.querySelector('.pn-btn__label') : null;
    var original = label ? label.textContent : '';

    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('pn-loading');
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          return body;
        });
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        if (window.PNSettings && window.PNSettings.cartAutoOpen) {
          openDrawer();
        } else {
          PN.toast('Produit ajouté au panier');
        }
      })
      .catch(function (err) {
        var message = (err && (err.description || err.message)) || 'Ce produit n’a pas pu être ajouté.';
        PN.toast(message);
      })
      .then(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('pn-loading');
        }
        if (label) label.textContent = original;
      });
  }

  /* ---------- Changement de quantité ---------- */
  function changeLine(line, quantity) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('pn-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        if (drawer) drawer.classList.remove('pn-loading');
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function () {
        if (drawer) drawer.classList.remove('pn-loading');
      });
  }

  /* ---------- Changement de variante sur une ligne ---------- */
  function swapVariant(lineKey, quantity, newVariantId, selectEl) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('pn-loading');
    if (selectEl) selectEl.disabled = true;

    /* Shopify ne permet pas de modifier la variante d'une ligne :
       on retire l'ancienne, puis on ajoute la nouvelle à quantité égale. */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(newVariantId, 10), quantity: quantity })
        }).then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw body;
            return body;
          });
        });
      })
      .then(function () {
        return refresh();
      })
      .then(function () {
        if (drawer) drawer.classList.remove('pn-loading');
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function (err) {
        if (drawer) drawer.classList.remove('pn-loading');
        if (selectEl) selectEl.disabled = false;
        PN.toast((err && err.description) || 'Ce modèle n’est plus disponible.');
        refresh();
      });
  }

  /* ---------- Délégation d'événements ---------- */
  function init() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form.matches && form.matches('form[action*="/cart/add"]') && !form.hasAttribute('data-pn-no-ajax')) {
        handleAddForm(form, e);
      }
    });

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest ? e.target.closest('[data-pn-cart-open]') : null;
      if (openBtn && window.PNSettings && window.PNSettings.cartType === 'drawer') {
        e.preventDefault();
        refresh().then(openDrawer);
        return;
      }

      var closeBtn = e.target.closest ? e.target.closest('[data-pn-cart-close]') : null;
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var qtyBtn = e.target.closest ? e.target.closest('[data-pn-qty]') : null;
      if (qtyBtn) {
        e.preventDefault();
        changeLine(parseInt(qtyBtn.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-qty'), 10));
        return;
      }

      var removeBtn = e.target.closest ? e.target.closest('[data-pn-remove]') : null;
      if (removeBtn) {
        e.preventDefault();
        changeLine(parseInt(removeBtn.getAttribute('data-line'), 10), 0);
      }
    });

    document.addEventListener('change', function (e) {
      var sel = e.target;
      if (!sel.matches || !sel.matches('[data-pn-line-variant]')) return;

      swapVariant(
        sel.getAttribute('data-key'),
        parseInt(sel.getAttribute('data-qty'), 10) || 1,
        sel.value,
        sel
      );
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();